/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,
  FormInput,
  FormCheckbox,
  FormTextarea,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "shards-react";
import moment from 'moment-timezone'
import DatePicker from "react-datepicker";
import EventNoteIcon from '@mui/icons-material/EventNote';
import TimePicker from 'react-bootstrap-time-picker';
import { accessCheck } from "../../utils/tools";
import { WEB_PAYMENT_URL } from "../../environmentVariables";
import PageTitle from "../../components/common/PageTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faSortUp, faSortDown, faSearch, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CONSTANTS } from "../../constants";
import "react-datepicker/dist/react-datepicker.css";
import { InsertInvitationOutlined } from "@mui/icons-material";
import { floor } from "lodash";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import Pagination from "../../components/common/Pagination";

const TenantVehicles = (props) => {
  const [location, setLocation] = useState(props.locations.find(location => location.id === props.user.location));
  const [whitelist, setWhitelist] = useState([]);
  const [sortBy, setSortBy] = useState('licenseAsc')
  const [search, setSearch] = useState('')
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false)
  const [licensePlate, setLicensePlate] = useState('')
  const [licensePlateState, setLicensePlateState] = useState(location.state)
  const [startDate, setStartDate] = useState(moment().toDate())
  const [startTime, setStartTime] = useState(moment().format("HH:mm"))
  const [howLong, setHowLong] = useState('today')
  const [untilADate, setUntilADate] = useState(false)
  const [endDate, setEndDate] = useState(moment().add(1, 'days').toDate())
  const [page, setPage] = useState(1)
  const [pageSize] = useState(25)
  // Get tenant's allowed zones
  const tenantAllowedZones = props.user.allowedZones || [];
  const locationZones = props.locations.find(location => location.id === props.user.location)?.zones || [];
  const availableZones = locationZones.filter(zone => 
    tenantAllowedZones.length === 0 || tenantAllowedZones.includes(zone.id)
  );
  
  // Calculate which allowed zones are missing from location zones
  const missingZoneIds = tenantAllowedZones.filter(zoneId => 
    !locationZones.some(zone => zone.id === zoneId)
  );
  

  
  const [zone, setZone] = useState(null)
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [filter, setFilter] = useState('active')
  const [showImportVehicleModal, setShowImportVehicleModal] = useState(false)
  const [csvFile, setCsvFile] = useState(null)
  const [showCsvTooltip, setShowCsvTooltip] = useState(false)


  useEffect(() => {
    props.getLocationWhitelist(location)
    document.title = 'Tenant vehicles: EnforcePlus admin';
    //!accessCheck(props.user, 'locations') && (window.location.href = '/')
    return (() => props.clearWhitelist())
  }, [])

  useEffect(() => {
    setWhitelist(props.whitelist.filter(vehicle => vehicle.tenant === props.user.id))
  }, [props.whitelist])

  // Add effect to respond to filter changes
  useEffect(() => {
    // When filter changes, make sure we're working with the latest data
    if (props.whitelist?.length > 0) {
      setWhitelist(props.whitelist.filter(vehicle => vehicle.tenant === props.user.id));
    }
  }, [filter]);

  const filterWhitelist = () => {
    if (whitelist?.length > 0) {
      let sortedWhitelist = [...whitelist];
      if (filter === 'active') {
        sortedWhitelist = sortedWhitelist.filter(item => moment(item.expiry_time).isAfter(moment()))
      }
      if (filter === 'expired') {
        sortedWhitelist = sortedWhitelist.filter(item => moment(item.expiry_time).isBefore(moment()))
      }
      if (search !== '') {
        sortedWhitelist = sortedWhitelist.filter(item => (
          item.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        ))
      }
      
      if (sortBy === 'startdateDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.start_time && b.start_time && moment(a.start_time).isBefore(moment(b.start_time)) ? 1 : -1);
      }
      if (sortBy === 'startdateAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.start_time && b.start_time && moment(a.start_time).isBefore(moment(b.start_time)) ? -1 : 1);
      }
      if (sortBy === 'expiresDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.expiry_time && b.expiry_time && moment(a.expiry_time).isBefore(moment(b.expiry_time)) ? 1 : -1);
      }
      if (sortBy === 'expiresAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.expiry_time && b.expiry_time && moment(a.expiry_time).isBefore(moment(b.expiry_time)) ? -1 : 1);
      }
      if (sortBy === 'licenseAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.license_plate.localeCompare(b.license_plate));
      }
      if (sortBy === 'licenseDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => b.license_plate.localeCompare(a.license_plate));
      }
      return sortedWhitelist
    }
    
  }

  const showLimitWarning = () => {
    alert('Sorry, you are at your maximum total permitted vehicles. You may need to delete one. Set the filter to All to view all your vehicles')
  }

  const whitelistAction = (item, action) => {
    if (action === 'remove_vehicle') {
      let confirm = window.confirm('Are you sure you want to remove this vehicle from the list?')
      if (confirm) {
        props.removeFromWhitelist(location, item)
      }
    }
    if (action === 'edit_vehicle') {
      editVehicle(item)
    }
  }

  const editVehicle = (item) => {
    setSelectedVehicle(item)
    setLicensePlate(item.license_plate)
    setLicensePlateState(item.license_plate_state)
    setStartDate(moment(item.start_time).toDate())
    setStartTime(moment(item.start_time).format("HH:mm"))
    if (moment().add(1, 'year') < moment(item.expiry_time)) {
      setHowLong('untilRemoved')
      setUntilADate(false)
    } else {
      setHowLong('today')
      setUntilADate(true)
    }
    setEndDate(moment(item.expiry_time).toDate())
    // Only set zone if it's in the available zones for this tenant
    const zoneExists = availableZones.find(z => z.id === item.zone);
    setZone(zoneExists ? item.zone : null)
    setShowAddVehicleModal(true)
  }

  const isValid = () => {
    let isValid = true
    if (licensePlate?.length < 3) {
      isValid = false
    }
    return isValid
  }

  const isImportValid = () => {
    let isValid = true
    if (!csvFile || csvFile.type !== 'text/csv') {
      isValid = false
    }
    return isValid
  }

  const calculateTimeFromNumbers = (numbers) => {
    let hours = Math.floor(numbers / 3600)
    let minutes = floor((numbers - (hours * 3600)) / 60)
    return {hours, minutes}
  }

  const addVehicleToWhitelist = () => {
    let data = {
      license_plate: licensePlate,
      license_plate_state: licensePlateState,
      zone: zone || null,
      tenant: props.user.id,
      source: props.user.name,
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    props.addVehicleToWhitelist(location, data)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setSelectedVehicle(null)
    setShowAddVehicleModal(false)
  }

  const editVehicleOnWhitelist = () => {
    let data = {
      license_plate: licensePlate,
      license_plate_state: licensePlateState,
      zone: zone || null,
      tenant: props.user.id,
      source: props.user.name,
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    props.editVehicleOnWhitelist(location, selectedVehicle, data)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setSelectedVehicle(null)
    setShowAddVehicleModal(false)
  }

  const importVehiclesToWhitelist = () => {
    // Check vehicle limit before importing
    const currentActiveVehicles = whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length
    const availableSlots = parseInt(props.user.vehicle_limit) - currentActiveVehicles
    
    if (availableSlots <= 0) {
      showLimitWarning()
      return
    }

    let data = {
      zone: zone || null,
      tenant: props.user.id,
      csvFile: csvFile
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    data.space_number = "2"
    data.source = props.user.name
    data.vehicle_limit = availableSlots // Pass the available slots to limit import
    props.importVehiclesToWhitelist(location, data)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setCsvFile(null)
    setShowImportVehicleModal(false)
  }

  const closeVehicleModal = () => {
    setSelectedVehicle(null)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setSelectedVehicle(null)
    setShowAddVehicleModal(false)
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}

      {/* First Row of Posts */}
      <Row>
        <Col>
          <Row noGutters className="page-header py-4">
            <PageTitle xs="12" sm="5" title={"Permitted vehicles: " + location.name} className="text-sm-left mb-3" />
            <Col xs="12" sm="7" className='text-right'>
              <Row>
                <Col className='text-right pl-0'>
                  <Button
                    theme="outline-accent"
                    onClick={() => setShowImportVehicleModal(true)}
                    className={'mr-2 mb-2'}
                    style={{
                      borderColor: 'rgba(33, 170, 115, 0.3)',
                      color: '#21AA73',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >Import vehicles</Button>
                  <Button
                    theme="accent"
                    className={'mb-2'}
                    onClick={() => {
                      if (parseInt(props.user.vehicle_limit) - whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length > 0) {
                        setShowAddVehicleModal(true)
                      } else {
                        showLimitWarning()
                      }
                    }}
                    style={{
                      fontWeight: '500',
                      boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)',
                      transition: 'all 0.2s ease'
                    }}
                  >Add vehicle</Button>
                </Col>
              </Row>
            </Col>
          </Row>
          {props.loadingWhitelist ? (
            <Row>
              <Col className={'text-center py-5'}>
                <ActivityIndicator />
                <p className="mt-3 text-muted">Loading vehicles...</p>
              </Col>
            </Row>
          ) : whitelist?.length === 0 ? (
            <>
              <Card small className="mb-4 mt-4" style={{
                borderRadius: '6px', 
                boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
                border: '1px solid #eaedf3'
              }}>
                <Row>
                  <Col xs={12} style={{paddingTop: 48, paddingBottom: 32, textAlign: 'center'}}>
                    <span style={{textAlign: 'center', fontWeight: 'bold', marginBottom: 12, fontSize: '18px', color: '#3D3C3E', display: 'block'}}>Get started and add your vehicles</span>
                    <span style={{textAlign: 'center', fontSize: 14, color: '#6c757d', display: 'block', maxWidth: '400px', margin: '12px auto 0', lineHeight: '1.5'}}>
                      Add your vehicles to the permitted list to avoid potential violations when your license plate is scanned.
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{paddingBottom: 64, textAlign: 'center'}}>
                    <Button
                      theme="accent"
                      className={'mr-3'}
                      onClick={() => setShowAddVehicleModal(true)}
                      style={{
                        fontWeight: '500',
                        padding: '10px 20px',
                        boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)',
                        transition: 'all 0.2s ease'
                      }}
                    >Add vehicle</Button>
                    <Button
                      theme="outline-accent"
                      onClick={() => setShowImportVehicleModal(true)}
                      style={{
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        color: '#21AA73',
                        fontWeight: '500',
                        padding: '10px 20px',
                        transition: 'all 0.2s ease'
                      }}
                    >Import vehicles</Button>
                  </Col>
                </Row>
              </Card>
            </>
          ) : (
            <>
              <Card small className="mb-4 mt-4" style={{
                borderRadius: '6px', 
                boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
                border: '1px solid #eaedf3'
              }}>
                <CardHeader className="border-bottom bg-white">
                  <Row>
                    <Col xs={8}>
                      <h6 className="m-0 font-weight-bold">Permitted Vehicles</h6>
                      <small className="text-muted">
                        {!!(parseInt(props.user.vehicle_limit) - whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length > 0) ?
                        ('You can add ' + (parseInt(props.user.vehicle_limit) - whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length) + ' more permitted vehicle' + ((parseInt(props.user.vehicle_limit) - whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length > 1) ? 's' : '')) :
                        ('You cannot add any more permitted vehicles')
                        }
                      </small>
                    </Col>
                    <Col xs={4} className='text-right pl-0'>
                      <div className="search-container" style={{ position: 'relative', maxWidth: '100%' }}>
                        <FormInput 
                          type={'text'} 
                          placeholder={'Search vehicles...'} 
                          value={search} 
                          onChange={event => setSearch(event.target.value)}
                          style={{
                            paddingLeft: '40px',
                            borderRadius: '20px',
                            border: '1px solid #E9ECEF',
                            fontSize: '14px',
                            height: '38px'
                          }}
                        />
                        <FontAwesomeIcon 
                          icon={faSearch} 
                          style={{
                            position: 'absolute',
                            left: '14px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#6c757d',
                            fontSize: '14px'
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12}>
                      <div className="d-flex align-items-center">
                        <FormSelect 
                          value={filter} 
                          onChange={event => setFilter(event.target.value)}
                          style={{
                            width: 'auto',
                            marginRight: '16px',
                            padding: '6px 12px',
                            fontSize: '13px',
                            border: '1px solid #E9ECEF',
                            borderRadius: '4px',
                            backgroundColor: '#FFFFFF'
                          }}
                        >
                          <option value={'active'}>Active vehicles</option>
                          <option value={'expired'}>Expired vehicles</option>
                          <option value={'all'}>All vehicles</option>
                      </FormSelect>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="p-0">
                  <div className="table-responsive">
                  <table className="table mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th scope="col" className="border-0" style={{padding: '16px 20px', fontSize: '13px', fontWeight: '600', color: '#3D5170'}}>
                            <div 
                              onClick={() => setSortBy(sortBy !== 'licenseAsc' ? 'licenseAsc' : 'licenseDesc')} 
                              style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
                            >
                              License plate
                              <div className="ml-1">
                                {sortBy === 'licenseAsc' && <FontAwesomeIcon icon={faSortUp} size="xs" />}
                                {sortBy === 'licenseDesc' && <FontAwesomeIcon icon={faSortDown} size="xs" />}
                              </div>
                            </div>
                        </th>
                          <th scope="col" className="border-0 d-none d-md-table-cell" style={{padding: '16px 20px', fontSize: '13px', fontWeight: '600', color: '#3D5170'}}>
                            <div 
                              onClick={() => setSortBy(sortBy !== 'startdateAsc' ? 'startdateAsc' : 'startdateDesc')} 
                              style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
                            >
                              Start time
                              <div className="ml-1">
                                {sortBy === 'startdateAsc' && <FontAwesomeIcon icon={faSortUp} size="xs" />}
                                {sortBy === 'startdateDesc' && <FontAwesomeIcon icon={faSortDown} size="xs" />}
                              </div>
                            </div>
                        </th>
                          <th scope="col" className="border-0" style={{padding: '16px 20px', fontSize: '13px', fontWeight: '600', color: '#3D5170'}}>
                            <div 
                              onClick={() => setSortBy(sortBy !== 'expiresAsc' ? 'expiresAsc' : 'expiresDesc')} 
                              style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
                            >
                              Expires
                              <div className="ml-1">
                                {sortBy === 'expiresAsc' && <FontAwesomeIcon icon={faSortUp} size="xs" />}
                                {sortBy === 'expiresDesc' && <FontAwesomeIcon icon={faSortDown} size="xs" />}
                              </div>
                            </div>
                        </th>
                          <th scope="col" className="border-0 d-none d-md-table-cell" style={{padding: '16px 20px', fontSize: '13px', fontWeight: '600', color: '#3D5170'}}>
                            Zone
                        </th>
                          <th scope="col" className="border-0 text-right" style={{padding: '16px 20px', fontSize: '13px', fontWeight: '600', color: '#3D5170'}}>
                            Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.whitelist && filterWhitelist()?.length > 0 && filterWhitelist()?.slice((page - 1) * pageSize, ((page - 1) * pageSize) + pageSize)?.map(item => {
                        return (
                            <tr key={item.id} style={{borderBottom: '1px solid #f8f9fa'}}>
                              <td style={{padding: '16px 20px', verticalAlign: 'middle'}}>
                                <div style={{fontWeight: '500', color: '#3D5170'}}>{item.license_plate}</div>
                                <small className="text-muted">{item.license_plate_state}</small>
                            </td>
                              <td style={{padding: '16px 20px', verticalAlign: 'middle'}} className="d-none d-md-table-cell">
                                <div style={{fontSize: '13px', color: '#3D5170'}}>
                                  {moment(item.start_time).format('MM/DD/YYYY')}
                                </div>
                                <small className="text-muted">{moment(item.start_time).format('h:mm a')}</small>
                            </td>
                              <td style={{padding: '16px 20px', verticalAlign: 'middle'}}>
                                <div style={{
                                  fontSize: '13px', 
                                  color: moment(item.expiry_time).isBefore(moment()) ? '#dc3545' : '#21AA73',
                                  fontWeight: '500'
                                }}>
                                {moment(item.expiry_time).diff(moment(), 'year') <= 0 ? (
                                    moment(item.expiry_time).format('MM/DD/YYYY')
                                ) : (
                                  'Permit'
                                )}
                                </div>
                                <small className="text-muted">
                                  {moment(item.expiry_time).diff(moment(), 'year') <= 0 ? (
                                    moment(item.expiry_time).format('h:mm a')
                                  ) : (
                                    'No expiration'
                                  )}
                                </small>
                            </td>
                              <td style={{padding: '16px 20px', verticalAlign: 'middle'}} className="d-none d-md-table-cell">
                                <span style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  color: '#6c757d'
                                }}>
                              {location.zones?.find(zone => zone.id === item.zone)?.name || 'All zones'}
                                </span>
                            </td>
                              <td className="text-right" style={{padding: '16px 20px', verticalAlign: 'middle'}}>
                                <FormSelect 
                                  id="feInputState" 
                                  onChange={event => {whitelistAction(item, event.target.value); event.target.value = ''}}
                                  style={{
                                    width: 'auto',
                                    padding: '6px 12px',
                                    fontSize: '13px',
                                    border: '1px solid #E9ECEF',
                                    borderRadius: '4px',
                                    backgroundColor: '#FFFFFF'
                                  }}
                                >
                                <option value={''}>Actions</option>
                                <option value={'edit_vehicle'}>Edit vehicle</option>
                                <option value={'remove_vehicle'}>Remove vehicle</option>           
                              </FormSelect>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  </div>
                </CardBody>
              </Card>
              <Pagination
                data={filterWhitelist()}
                pageSize={pageSize}
                page={page}
                onPageChange={(newPage) => setPage(newPage)}      
              />
            </>
          )}
          
        </Col>
      </Row>

      {/* Import Vehicles Modal */}
      <Modal size={'md'} open={showImportVehicleModal} toggle={() => setShowImportVehicleModal(false)}>
        <ModalHeader style={{
          position: 'sticky',
          top: 0,
          backgroundColor: '#fff',
          zIndex: 1,
          borderBottom: '1px solid #E9ECEF'
        }}>Import Permitted Vehicles</ModalHeader>
        <ModalBody className={'p-4'} style={{
          maxHeight: 'calc(100vh - 180px)', // slightly less to account for header/footer
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingBottom: 0 // remove bottom padding so footer is flush
        }}>
          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>Upload CSV File</h6>
            <div className="csv-upload-container" style={{
              border: '2px dashed #E9ECEF',
              borderRadius: '8px',
              padding: '24px',
              textAlign: 'center',
              backgroundColor: '#F8F9FA',
              transition: 'all 0.2s ease',
              position: 'relative'
            }}>
              <FormInput
                id="csvUpload"
                type={'file'}
                accept=".csv"
                onChange={(event) => setCsvFile(event.target.files[0])}
                style={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '0'
                }}
              />
              <small className="text-muted mt-3 d-block">
                {csvFile ? csvFile.name : 'Select or drag a CSV file here'}
              </small>
              <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
                <>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    style={{
                      color: '#21AA73',
                      cursor: 'pointer'
                    }}
                    onClick={() => setShowCsvTooltip(!showCsvTooltip)}
                  />
                  {showCsvTooltip && (
                    <div style={{
                      position: 'absolute',
                      top: 'calc(100% + 10px)',
                      right: '0',
                      backgroundColor: '#fff',
                      padding: '12px 16px',
                      borderRadius: '6px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      border: '1px solid #E9ECEF',
                      width: '280px',
                      zIndex: 1000,
                      fontSize: '13px',
                      color: '#3D5170',
                      whiteSpace: 'normal'
                    }}>
                      <div style={{ marginBottom: '8px' }}>
                        Upload a CSV file containing vehicle information. The file should have two columns with headers:
                      </div>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: '0'
                      }}>
                        <li style={{ marginBottom: '4px' }}>
                          • "license plate" - The vehicle's license plate number
                        </li>
                        <li>
                          • "state" - The state/province of registration
                        </li>
                      </ul>
                      <div style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '10px',
                        transform: 'translateX(-50%) rotate(45deg)',
                        width: '12px',
                        height: '12px',
                        backgroundColor: '#fff',
                        border: '1px solid #E9ECEF',
                        borderBottom: 'none',
                        borderRight: 'none'
                      }}></div>
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>

          {availableZones.length > 0 && (
            <div style={{ marginBottom: '32px' }}>
              <h6 style={{
                fontSize: '15px',
                color: '#3D5170',
                fontWeight: '600',
                marginBottom: '16px'
              }}>Permitted Zone</h6>
              <FormSelect
                id="zoneSelect"
                value={zone}
                onChange={(event) => setZone(event.target.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #E9ECEF',
                  borderRadius: '4px',
                  backgroundColor: '#FFFFFF',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              >
                <option value={null}>All zones</option>
                {availableZones.map(zone => (
                  <option key={zone.id} value={zone.id}>{zone.name}</option>
                ))}
              </FormSelect>
            </div>
          )}

          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>Start Date & Time</h6>
            <Row>
              <Col xs={7}>
                <InputGroup seamless className="mb-2" style={{ borderRadius: 4 }}>
                  <DatePicker
                    className={'form-control'}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    todayButton="Today"
                    shouldCloseOnSelect={false}
                    customInput={
                      <FormInput style={{ height: '44px' }} />
                    }
                    style={{
                      width: '100%',
                      borderRadius: '4px 0 0 4px',
                      border: '1px solid #E9ECEF',
                      padding: '10px 12px',
                      fontSize: '14px',
                      height: '44px'
                    }}
                  />
                  <InputGroupAddon type="append">
                    <InputGroupText style={{
                      backgroundColor: '#F8F9FA',
                      border: '1px solid #E9ECEF',
                      borderLeft: 'none'
                    }}>
                      <EventNoteIcon style={{ color: '#21AA73', fontSize: '18px' }} />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xs={5}>
                <TimePicker
                  start="00:00"
                  end="23:59"
                  step={30}
                  value={startTime}
                  onChange={(time) => setStartTime(time)}
                  style={{
                    width: '100%',
                    height: '44px',
                    border: '1px solid #E9ECEF',
                    borderRadius: '0 4px 4px 0',
                    padding: '10px 12px',
                    fontSize: '14px'
                  }}
                />
              </Col>
            </Row>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>Duration</h6>
            <Row>
              <Col xs={12}>
                <FormSelect
                  value={howLong}
                  onChange={(event) => setHowLong(event.target.value)}
                  style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid #E9ECEF',
                    borderRadius: '4px',
                    backgroundColor: '#FFFFFF',
                    transition: 'all 0.2s ease',
                    height: '44px'
                  }}
                >
                  <option value={'today'}>Today only</option>
                  <option value={'week'}>1 week</option>
                  <option value={'month'}>1 month</option>
                  <option value={'year'}>1 year</option>
                  <option value={'untilRemoved'}>Until removed</option>
                  <option value={'custom'}>Custom end date</option>
                </FormSelect>
              </Col>
            </Row>
          </div>

          {(howLong === 'custom' || untilADate) && (
            <div style={{ marginBottom: '32px' }}>
              <h6 style={{
                fontSize: '15px',
                color: '#3D5170',
                fontWeight: '600',
                marginBottom: '16px'
              }}>End Date</h6>
              <InputGroup seamless className="mb-2" style={{ borderRadius: 4 }}>
                <InputGroupAddon type="prepend">
                  <InputGroupText>
                    <span style={{fontSize: 18}}><EventNoteIcon fontSize={'inherit'} /></span>
                  </InputGroupText>
                </InputGroupAddon>
                <DatePicker
                  className={'form-control'}
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  todayButton="Today"
                  shouldCloseOnSelect={false}
                  customInput={
                    <FormInput style={{ height: '44px' }} />
                  }
                  style={{
                    width: '100%',
                    borderRadius: '4px',
                    border: '1px solid #E9ECEF',
                    padding: '10px 12px',
                    fontSize: '14px',
                    height: '44px'
                  }}
                />
              </InputGroup>
            </div>
          )}

          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '16px', 
            borderRadius: '6px', 
            border: '1px solid #e9ecef',
            marginBottom: '24px'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '8px' 
            }}>
              <FontAwesomeIcon 
                icon={faInfoCircle} 
                style={{ color: '#21AA73', marginRight: '8px' }} 
              />
              <span style={{ fontWeight: '600', color: '#3D5170' }}>
                Vehicle Limit
              </span>
            </div>
            <p style={{ margin: '0', fontSize: '13px', color: '#6c757d' }}>
              You can import up to {parseInt(props.user.vehicle_limit) - whitelist.filter(item => moment(item.expiry_time).isAfter(moment())).length} more vehicles based on your current limit.
            </p>
          </div>
        </ModalBody>
        <ModalFooter style={{
          borderTop: '1px solid #E9ECEF',
          padding: '16px 24px',
          background: '#fff',
          position: 'sticky',
          bottom: 0,
          zIndex: 2,
          boxShadow: '0 -2px 8px rgba(0,0,0,0.04)'
        }}>
          <Row className="w-100">
            <Col xs={6}>
              <Button 
                theme="white" 
                onClick={() => setShowImportVehicleModal(false)}
                style={{
                  border: '1px solid #E9ECEF',
                  color: '#6c757d'
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs={6} className="text-right">
              <Button 
                theme="accent" 
                disabled={!isImportValid()}
                onClick={() => importVehiclesToWhitelist()}
                style={{
                  fontWeight: '500',
                  boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)'
                }}
              >
                Import Vehicles
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>

      <Modal size={'md'} open={showAddVehicleModal} toggle={() => closeVehicleModal()}>
        <ModalHeader>{selectedVehicle?.id ? 'Edit' : 'Add'} a permitted vehicle</ModalHeader>
        <ModalBody className={'p-4'}>
          <Row form className={'mb-3'}>
            <Col xs={7} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Enter the license plate</label>
              <FormInput 
                type='text' 
                value={licensePlate} 
                onChange={(event) => setLicensePlate(event.target.value.toUpperCase().replace(/\s/gim, ''))}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease'
                }}
              />
            </Col>
            <Col xs={5} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Enter the State</label>
              <FormSelect 
                value={licensePlateState} 
                onChange={(event) => setLicensePlateState(event.target.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              >
                {CONSTANTS.US_STATES.map(state => (
                  <option key={state.abbreviation} value={state.abbreviation}>{state.name}</option>
                ))}
                {CONSTANTS.CA_STATES.map(state => (
                  <option key={`CA-${state.abbreviation}`} value={state.abbreviation}>CA - {state.name}</option>
                ))}
              </FormSelect>
            </Col>
          </Row>
          {missingZoneIds.length > 0 && (
            <Alert theme="danger" className="mb-3">
              <strong>Zone Configuration Error:</strong> The following allowed zone IDs are not found in the current location's zone list: 
              <br />
              <code style={{backgroundColor: '#f8f9fa', padding: '2px 4px', borderRadius: '3px'}}>
                {missingZoneIds.join(', ')}
              </code>
              <br />
              <small>Please contact your administrator to update the zone configuration.</small>
            </Alert>
          )}
          {availableZones.length > 0 && (
            <Row form className={'mb-2'}>
              <Col xs={12} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Which zone is the vehicle permitted in</label>
                <FormSelect value={zone || ''} onChange={(event) => setZone(event.target.value || null)}>
                  <option value="">All zones</option>
                  {availableZones.map(zone => (
                    <option key={zone.id} value={zone.id}>{zone.name}</option>
                  ))}
                </FormSelect>
              </Col>
            </Row>
          )}
          <Row form className={'mb-3'}>
            <Col xs={12} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>When would you like to add the vehicle</label>
            </Col>
          </Row>
          <Row form className={'mb-3'}>
            <Col xs={7}>
              <InputGroup seamless className="mb-2" style={{ borderRadius: 4 }}>
                <DatePicker
                  className={'form-control'}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                  todayButton="Today"
                  shouldCloseOnSelect={false}
                  customInput={
                    <FormInput style={{ height: '44px' }} />
                  }
                  style={{
                    width: '100%',
                    borderRadius: '4px 0 0 4px',
                    border: '1px solid #E9ECEF',
                    padding: '10px 12px',
                    fontSize: '14px',
                    height: '44px'
                  }}
                />
                <InputGroupAddon type="append">
                  <InputGroupText style={{
                    backgroundColor: '#F8F9FA',
                    border: '1px solid #E9ECEF',
                    borderLeft: 'none'
                  }}>
                    <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Col>
            <Col xs={5}>
              <TimePicker 
                start="00:00" 
                end="23:55" 
                step={5} 
                value={startTime} 
                onChange={(time) => setStartTime(time)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              />
            </Col>
          </Row>
          {!untilADate && (
            <>
              <Row form className={'mb-3'}>
                <Col xs={12} className="form-group">
                  <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>How long should the vehicle be valid for?</label>
                </Col>
              </Row>
              <Row form className={'mb-3'}>
              <Col xs={7} className="form-group">
                  <FormSelect 
                    value={howLong} 
                    onChange={(event) => setHowLong(event.target.value)}
                    style={{
                      padding: '10px 12px',
                      fontSize: '14px',
                      border: '1px solid #dfe3e9',
                      borderRadius: '4px',
                      transition: 'all 0.2s ease',
                      height: '44px'
                    }}
                  >
                  <option value={'today'}>Today only</option>
                  <option value={'week'}>1 week</option>
                  <option value={'month'}>1 month</option>
                  <option value={'year'}>1 year</option>
                  <option value={'untilRemoved'}>Until removed</option>
                </FormSelect>
              </Col>
                <Col xs={5} className="form-group pt-4">
                  <FormCheckbox 
                    checked={untilADate} 
                    onChange={() => setUntilADate(!untilADate)}
                    style={{
                      fontSize: '14px',
                      color: '#495057'
                    }}
                  >
                    Until a specific date
                  </FormCheckbox>
              </Col>
            </Row>
            </>
          )}
          {untilADate && (
            <Row form className={'mb-3'}>
              <Col xs={7} className="form-group">
                <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Select an end date</label>
                <InputGroup seamless style={{borderRadius: 4}}>
                  <DatePicker
                    className={'form-control'}
                    selected={endDate}
                    minDate={startDate}
                    onChange={(date) => setEndDate(date)}
                    shouldCloseOnSelect={false}
                    customInput={
                      <FormInput style={{ height: '44px' }} />
                    }
                    style={{
                      width: '100%',
                      borderRadius: '4px 0 0 4px',
                      border: '1px solid #E9ECEF',
                      padding: '10px 12px',
                      fontSize: '14px',
                      height: '44px'
                    }}
                  />
                  <InputGroupAddon type="append">
                    <InputGroupText style={{
                      backgroundColor: '#F8F9FA',
                      border: '1px solid #E9ECEF',
                      borderLeft: 'none'
                    }}>
                      <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xs={5} className="form-group pt-4">
                <FormCheckbox 
                  checked={untilADate} 
                  onChange={() => setUntilADate(!untilADate)}
                  style={{
                    fontSize: '14px',
                    color: '#495057'
                  }}
                >
                  Until a specific date
                </FormCheckbox>
              </Col>
            </Row>  
          )}
        </ModalBody>
        <ModalFooter style={{display: 'block !important', padding: '1rem 1.5rem', borderTop: '1px solid #dfe1e3'}}>
          <Row>
            <Col xs={6} className={'text-left'}>
              <Button
                theme="light"
                onClick={() => closeVehicleModal()}
                className={'mr-2'}
                style={{
                  fontWeight: '500',
                  padding: '0.5rem 1rem',
                  boxShadow: 'none'
                }}
              >Cancel</Button>
            </Col>
            <Col xs={6} className={'text-right'}>
              <Button
                theme="accent"
                disabled={!isValid()}
                onClick={() => selectedVehicle?.id ? editVehicleOnWhitelist() : addVehicleToWhitelist()}
                style={{
                  fontWeight: '500',
                  padding: '0.5rem 1rem',
                  boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)'
                }}
              >Save</Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>            
    </Container>
  );
}

export default TenantVehicles;
